import i18n from 'modules/core/lib/i18n'

import type { View } from 'modules/shift_management/lib/types'

export const rowsSelectedCopy = (view: View, rowsSelectedCount: number) => {
  return view.isByEmployees
    ? i18n.tp('shift_management.employees_selected', {
        count: rowsSelectedCount,
      })
    : i18n.tp('shift_management.work_area_selected', {
        count: rowsSelectedCount,
      })
}

export const daysOrHoursCopy = (view: View, daysSelectedCount: number) => {
  return view.isDaily
    ? i18n.tp('shift_management.hours_selected', {
        count: daysSelectedCount,
      })
    : i18n.tp('shift_management.days_selected', {
        count: daysSelectedCount,
      })
}
